import React from 'react'

const skillGroups = [
  {
    title: 'Frontend Developer',
    columns: [
      [
        { name: 'HTML', level: 'Intermediate', icon: 'devicon-html5-plain colored' },
        { name: 'CSS', level: 'Intermediate', icon: 'devicon-css3-plain colored' },
        { name: 'JavaScript', level: 'Intermediate', icon: 'devicon-javascript-plain colored' },
        { name: 'TypeScript', level: 'Intermediate', icon: 'devicon-typescript-plain colored' },
      ],
      [
        { name: 'React', level: 'Intermediate', icon: 'devicon-react-original colored' },
        { name: 'Angular', level: 'Intermediate', icon: 'devicon-angular-plain colored' },
        { name: 'Git', level: 'Intermediate', icon: 'devicon-git-plain colored' },
      ],
    ],
  },
  {
    title: 'Backend Developer',
    columns: [
      [
        { name: 'Nodejs', level: 'Intermediate', icon: 'devicon-nodejs-plain colored' },
        { name: 'NestJS', level: 'Intermediate', icon: 'devicon-nestjs-original colored' },
        { name: 'Express', level: 'Intermediate', icon: 'devicon-express-original', invert: true },
      ],
      [
        { name: 'PostgreSQL', level: 'Intermediate', icon: 'devicon-postgresql-plain colored' },
        { name: 'MongoDB', level: 'Intermediate', icon: 'devicon-mongodb-plain colored' },
        { name: 'Firebase', level: 'Intermediate', icon: 'devicon-firebase-plain colored' },
      ],
    ],
  },
  {
    title: 'API Tools',
    columns: [
      [
        { name: 'Postman', level: 'Intermediate', icon: 'devicon-postman-plain colored' },
        { name: 'Insomnia', level: 'Basic', icon: 'devicon-insomnia-plain colored' },
      ],
    ],
  },
  {
    title: 'Other Technologies',
    columns: [
      [
        { name: 'Angular Material', level: 'Basic', icon: 'devicon-angular-plain colored' },
        { name: 'Bootstrap', level: 'Basic', icon: 'devicon-bootstrap-plain colored' },
        { name: 'TailwindCSS', level: 'Basic', icon: 'devicon-tailwindcss-original colored' },
        { name: 'AWS', level: 'Basic', icon: 'fi fi-sr-cloud', mono: true },
      ],
    ],
  },
]

const SkillsComponent = () => {
  return (
    <div className="container section" id='skills'>
      <div className="section__header">
        <span className="section__eyebrow">&lt;Skills /&gt;</span>
        <h2 className="section__title">My Skills</h2>
      </div>
      <div className="skills__content grid">
        {skillGroups.map((group) => (
          <div className="skills__area" key={group.title}>
            <h3 className="skills__title">{group.title}</h3>
            <div className="skills__box">
              {group.columns.map((column, colIndex) => (
                <div className="skills__group" key={colIndex}>
                  {column.map((skill) => (
                    <div className="skills__data" key={skill.name}>
                      <span className={`skills__icon${skill.invert ? ' skills__icon--invert' : ''}${skill.mono ? ' skills__icon--mono' : ''}`}>
                        <i className={skill.icon}></i>
                      </span>
                      <div>
                        <span className="skills__name">{skill.name}</span>
                        <br />
                        <span className="skills__level">{skill.level}</span>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default SkillsComponent;
